import React, { useEffect } from 'react';
import {
  ModalWrapper,
  ModalChildren,
  Image,
  CloseWrapper,
  ModalContent,
} from './styled.modal';
import { CloseCircle } from '../../icons/CloseCircle';
import { IModal } from '../../../@types/modal';
import { Overlay } from '../Overlay';
import { RequireOnlyTwoOptional } from '../../../@types/genericTypes';

export function Modal ({
  isOpen,
  children,
  handleModalClose,
  imageUrl,
  isShowCloseIcon = false,
  isFullModal,
  canCloseModal = true,
}: RequireOnlyTwoOptional<IModal, 'imageUrl', 'children'>) {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  return (
    <>
      <Overlay
        handleDisplayOverlay={handleModalClose}
        canCloseModal={canCloseModal}
      />
      <ModalWrapper>
        <ModalContent>
          {isShowCloseIcon && (
            <CloseWrapper onClick={handleModalClose}>
              <CloseCircle />
            </CloseWrapper>
          )}
          {imageUrl && <Image isContent={children} url={imageUrl} />}
          {children && (
            <ModalChildren isFullModal={isFullModal} imageUrl={imageUrl}>
              {children}
            </ModalChildren>
          )}
        </ModalContent>
      </ModalWrapper>
    </>
  );
}
